import PropTypes from 'prop-types';
import { picturePropTypes } from './components/Picture/PicturePropTypes';
import { detailsPropTypes } from './components/Details/DetailsPropTypes';
export const articleTilePropTypes = {
  /**
   * Picture attributes: src, alt and image className
   */
  picture: PropTypes.shape(picturePropTypes),
  /**
   * Category content: label and href
   */
  category: detailsPropTypes.category,
  /**
   * Date of publish - MMM DD
   */
  date: PropTypes.string,
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Href of article
   */
  href: PropTypes.string,
  /**
   * Description content
   */
  description: PropTypes.string,
  /**
   * If true ArticleTile is large
   */
  isLarge: PropTypes.bool
};